module.exports = __webpack_public_path__ + "static/media/NOTCH.680b7097.svg";